module.exports = __webpack_public_path__ + "static/media/arrow.f73e8f1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow.svg
// module id = 378
// module chunks = 0